import { useTranslation } from "@opendash/i18n";
import { Link } from "@opendash/router";
import { Button, Modal, QRCode, Tooltip } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";
import { SaveTicketValues, TicketSaveForm } from "../..";
import { Ticket_QR_Code } from "../../../../js/parsegenerated";

type Props = {
  value?: string;
  onChange?: (value: string) => void;
  object?: Ticket_QR_Code;
};

export const QRCodeInput = observer((props: Props) => {
  const t = useTranslation();
  const [open, setOpen] = React.useState(false);

  const object = React.useMemo(() => {
    if (!props.value) return undefined;
    try {
      return JSON.parse(props.value);
    } catch (e) {
      return undefined;
    }
  }, [props.value]);

  async function handleSave(values: SaveTicketValues) {
    if (!values.message?.description) values.message = undefined;
    const jsonString = JSON.stringify(values);
    props.onChange?.(jsonString);
    setOpen(false);
  }

  return (
    <>
      {!props.onChange && (
        <Link to={`/admin/parse/print/${props.object?.id}`}>
          <Tooltip title={t("maintenance:admin.ticket.qr.tooltip")}>
            <QRCode value={props.object?.id} />
          </Tooltip>
        </Link>
      )}
      {props.onChange && (
        <>
          <Button onClick={() => setOpen(true)}>
            {t("maintenance:admin.ticket.qr.config.btn")}
          </Button>
          <Modal
            open={open}
            onCancel={() => setOpen(false)}
            // onClose={() => setOpen(false)}
            footer={null}
            width="80%"
          >
            <TicketSaveForm initialValues={object} overrideSave={handleSave} />
          </Modal>
        </>
      )}
    </>
  );
});
